import styled, { css } from 'styled-components';
import { Poppins } from './Poppins';

export const GradientText = styled(Poppins)<{ $vertical?: boolean; $noTransform?: boolean }>`
  background: ${({ $vertical, theme }) => ($vertical ? theme.colors.gradientVertical : theme.colors.gradient)};
  -webkit-background-clip: text;
  font-weight: bold;
  text-transform: ${({ $noTransform }) => ($noTransform ? 'none' : 'uppercase')};
  color: transparent;
`;

export const GradientTextAction = styled(GradientText)<{ $underline?: boolean; $disabled?: boolean }>`
  text-transform: none !important;
  cursor: pointer;
  display: inline-block;
  position: relative;
  user-select: none;

  ${({ $underline }) =>
    $underline &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 80%;
        left: 0;
        right: 0;
        height: 1px;
        background: ${({ theme }) => theme.colors.gradient};
      }
    `};

  .underline {
    position: relative;
    background: ${({ theme }) => theme.colors.gradient};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    &:before {
      content: '';
      position: absolute;
      top: 80%;
      left: 0;
      right: 0;
      height: 1px;
      background: ${({ theme }) => theme.colors.gradient};
    }
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: none;
      -webkit-background-clip: unset;
      -webkit-text-fill-color: unset;
      color: ${({ theme }) => theme.colors.cflowerBlue};
      pointer-events: none;

      &:before {
        display: none;
      }

      .underline {
        color: ${({ theme }) => theme.colors.cflowerBlue};
        background: none;
        -webkit-background-clip: unset;
        -webkit-text-fill-color: unset;

        &:before {
          display: none;
        }
      }
    `};
`;
